// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal-container_backdrop__2c_Va","modal":"modal-container_modal__X8721"};